import { Signal } from '@modules';

/**
 * AttributesMap component constants
 * @returns {variables}
 */

export const SIGNAL_TYPES: Signal['type'][] = ['textual', 'numeric'];
